<template>
    <v-card
        class="ml-3 mt-3"
        :width="width"
        :hover="!!transferDestination"
        :ripple="!!transferDestination"
        :to="transferDestination"
        :disabled="disabled"
    >
        <div style="position: absolute; top: -12px; left: -12px">
            <v-avatar :color="iconBgColor" class="elevation-5" size="62">
                <v-icon dark size="30">
                    {{ icon }}
                </v-icon>
            </v-avatar>
        </div>
        <v-card-title>
            <v-layout style="height: 3em">
                <v-flex class="text-right align-self-center pl-9">
                    <span style="white-space: pre-wrap" v-text="statusAlias" />
                </v-flex>
            </v-layout>
        </v-card-title>
        <v-card-text>
            <v-layout>
                <v-flex class="text-right">
                    <span class="text-h3">{{ counter }}</span>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import { Prop, Component, Vue } from 'vue-property-decorator';
import type { RawLocation } from 'vue-router';

@Component
export default class StatusCountCard extends Vue {
    @Prop({ default: '' }) readonly icon: string;
    @Prop({ default: undefined }) readonly iconBgColor: string | undefined;
    @Prop({ default: '' }) readonly statusAlias: string;
    @Prop({ type: [String, Number], default: '' }) readonly counter: string | number;
    @Prop({ type: [String, Number], default: undefined }) readonly width: string | number | undefined;
    @Prop({ default: undefined }) readonly to: RawLocation | undefined;
    @Prop({ default: false }) readonly disabled: boolean;

    /**
     * getter
     */
    get transferDestination(): RawLocation | undefined {
        return this.to;
    }
}
</script>
